import AuthRoutesList from 'pages/platform/auth/constants';
import DashboardRoutesList from 'pages/platform/dashboard/constants';
import SettingRoutesList from 'pages/platform/dashboard/settings/constants';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'redux/platform/hooks';
import { getPlatformBaseUrl } from 'utils/getBaseUrl';

import { Button } from '@limepayments/cosmic';
import ClickAwayListener from '@mui/material/ClickAwayListener';

interface Props {
  onCloseSettingClick: (val: boolean) => void;
}

function SettingsDropdown({ onCloseSettingClick }: Props) {
  const navigate = useNavigate();
  const { platformName } = useAppSelector((state) => ({
    platformName: state.config.platformName,
  }));

  return (
    <ClickAwayListener onClickAway={() => onCloseSettingClick(false)}>
      <div className="lp-flex lp-flex-column">
        {/* <div className="setting-dropdown-header">
          <p className="lp-flex lp-justify-start lp-items-center lp-font-button fw-medium lp-w-full btnText mb-8">
            Simon Cusack
          </p>
          <Text alignment="left" tagName="span" variant="caption" className="userRole">
            Admin
          </Text>
        </div> */}
        <div className="setting-dropdown-body">
          <ul>
            <li>
              <Button
                size="medium"
                variant="ghost"
                className="lp-w-full btnText"
                onClick={() =>
                  navigate(
                    `${getPlatformBaseUrl(platformName)}/dashboard/${DashboardRoutesList.SETTINGS_ROUTE}/${
                      SettingRoutesList.SETTINGS_PROFILE
                    }`,
                  )
                }
                testId="setting-menu-link"
              >
                Settings
              </Button>
            </li>
            <li>
              <Button
                onClick={() => navigate(`${getPlatformBaseUrl(platformName)}/${AuthRoutesList.LOGOUT_PAGE}`)}
                size="medium"
                variant="ghost"
                className="lp-w-full btnText"
              >
                Logout
              </Button>
            </li>
          </ul>
        </div>
      </div>
    </ClickAwayListener>
  );
}

export default SettingsDropdown;
